/**
 * Centralized instrument status configuration
 * Single source of truth for status colors and inactive status definitions
 */

export const INSTRUMENT_STATUS_CONFIG: Record<
  string,
  { color: StatusColor; isInactive: boolean }
> = {
  ACTIVE: { color: 'success', isInactive: false },
  LIVE: { color: 'success', isInactive: false },
  PENDING: { color: 'warning', isInactive: false },
  DRAFT: { color: 'warning', isInactive: false },
  INACTIVE: { color: 'error', isInactive: true },
  DELETED: { color: 'error', isInactive: true },
  DELISTED: { color: 'error', isInactive: true },
  SUSPENDED: { color: 'error', isInactive: true },
  DEPRECATED: { color: 'error', isInactive: true },
};

export type StatusColor = 'success' | 'warning' | 'error' | 'default';

/**
 * Check if a status is considered inactive
 */
export const isInactiveStatus = (
  status: string | null | undefined
): boolean => {
  if (!status || typeof status !== 'string') return false;
  return INSTRUMENT_STATUS_CONFIG[status.toUpperCase()]?.isInactive ?? false;
};

/**
 * Get the color for a given status
 */
export const getStatusColor = (
  status: string | null | undefined
): StatusColor => {
  if (!status || typeof status !== 'string') return 'default';
  return INSTRUMENT_STATUS_CONFIG[status.toUpperCase()]?.color ?? 'default';
};
